import React from 'react'
import health from '../assets/pozadie.png'
import Grid from "@material-ui/core/Grid";


function StartPage() {
    return (
        <div>
            <Grid container className="shadow flexColumn" style={{ flex: 1, marginTop: 20, padding: 0, borderRadius: 8}}>
                <Grid  style={{ flex: 1, margin: 'auto', padding: 10}}>
                    <h1 style={{fontSize: "300%"}}>We <u>care</u> for Health care</h1>
                    <h2>Your pain is our pain</h2>
                    <h2>We make health great again!</h2>
                    <p><i>Please Sign up or Login as a patient or a doctor.</i></p>
                </Grid>
                <Grid style={{ flex: 1 }}>
                    <img src={health} alt='health' style={{width: '100%', height:'100%', borderTopRightRadius: 8, borderBottomRightRadius: 8}} />
                </Grid>
            </Grid>
        </div>
    )
}

export default StartPage
